import '../../sass/plugins/our_team.scss';
import { MEDIUM_SCREEN, EXTRA_LARGE_SCREEN } from '../consts';

const XXL_SCREEN = EXTRA_LARGE_SCREEN + 200;

$(() => {
  const itemsCount = $('.our-team-carousel-element').length;
  const sliderTop = $('#our-team-carousel');
  const sliderBottom = $('#our-team-carousel-details');
  const nextArrow = $('#our-team-carousel-next-arrow');
  const prevArrow = $('#our-team-carousel-prev-arrow');
  const mediumSlidesToShow = itemsCount > 3 ? 3 : 1;
  const xxlSlidesToShow = itemsCount > 5 ? 5 : mediumSlidesToShow;
  sliderTop.slick({
    lazyLoad: 'ondemand',
    infinite: true,
    variableWidth: true,
    centerMode: true,
    mobileFirst: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipe: true,
    nextArrow,
    prevArrow,
    asNavFor: '#our-team-carousel-details',
    responsive: [
      {
        breakpoint: MEDIUM_SCREEN,
        settings: {
          variableWidth: false,
          slidesToShow: mediumSlidesToShow,
          centerPadding: '30px',
        },
      },
      {
        breakpoint: XXL_SCREEN,
        settings: {
          variableWidth: false,
          slidesToShow: xxlSlidesToShow,
          centerPadding: '20px',
        },
      },
    ],
  });

  sliderBottom.slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    fade: true,
    swipe: true,
    mobileFirst: true,
    asNavFor: '#our-team-carousel',
  });
});
